import { TypeNumberRounding } from "./TypeNumberRounding";
export var mapNumberRounding = new Map([
    [TypeNumberRounding.None, function (a) { return a; }],
    [TypeNumberRounding.Floor, Math.floor],
    [TypeNumberRounding.Round, Math.round],
    [TypeNumberRounding.Ceil, Math.ceil],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/round-format/mapNumberRounding.ts
// module id = 1247
// module chunks = 3